import { atom } from "jotai";

export const appBarStickyHeightAtom = atom<number>(0);
